import React from 'react';
import { X } from 'lucide-react';
import { useOnboarding } from '../onboarding/OnboardingContext';
import { cn } from '@/lib/utils';

/**
 * Dismissible contextual help — calm, optional, stored in onboarding dismissedHints.
 */
export function ContextualGuideTip({
  tipId,
  title,
  children,
  className,
}) {
  const { isHintDismissed, dismissHint } = useOnboarding();

  if (isHintDismissed(`guide-${tipId}`)) return null;

  return (
    <div
      className={cn(
        'relative rounded-xl border border-[hsl(38_14%_86%)]/90 bg-gradient-to-r from-[hsl(42_28%_99%)] to-[hsl(40_24%_98%)] px-4 py-3.5 pr-10 text-sm leading-relaxed text-muted-foreground shadow-sm',
        className
      )}
      data-testid={`guide-tip-${tipId}`}
      role="note"
    >
      {title ? <p className="mb-1 font-medium text-foreground/85">{title}</p> : null}
      <div>{children}</div>
      <button
        type="button"
        onClick={() => dismissHint(`guide-${tipId}`)}
        className="absolute right-2 top-2 rounded-md p-1 text-muted-foreground/60 transition hover:bg-muted/30 hover:text-foreground"
        aria-label="Dismiss tip"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}

export default ContextualGuideTip;
